import axios from "axios";
import "react-toastify/dist/ReactToastify.css";

export default class ApiUtils {
  static post_GetOrderDetial = "ProjectAssign/GetProjectDetial";
  static post_GetAllProjectDetial = "ProjectAssign/GetAllProjectDetial";
  static get_GetAllProjectDetial = "ProjectAssign/sendGetAllProjectDetial";

  // 單取列表不整理 透過列表數量需求 (int listCount)
  static get_GetProjectListlByCount = "ProjectAssign/GetProjectListlByCount";
  
  static get_GetProjectListlByCount = "ProjectAssign/GetProjectListlByCount";
  //操作端拿專案列表 單一案子 (int projectDetialiD)
  static get_GetProjectDetialByPid = "ProjectAssign/GetProjectDetialByPid";

  static url_type = "pro";
  static cors = "";
  //static cors = 'https://cors-anywhere.herokuapp.com/';
  //static cors = '';
  static url = "https://subprpapp.azurewebsites.net/";
  // static url = "https://localhost:44395/";

  //翻譯資料新增與取得
  //static post_DetialJsonData = 'Project/getDetialJsonData';
  static post_DetialJsonData_byProjectDetial_fId =
    "Project/getDetialJsonData_by_ProjectDetial_fId";
  //翻譯內容
  static get_DetialJsonDataString = "Project/getDetialJsonDataString"; //getDetialJsonDataString?fId=8
  //新增
  //static post_AddDetialJsonData = 'Project/AddDetialJsonData';
  static post_AddDetialJsonData_email = "Project/AddDetialJsonData_email";

  //拿回最新的翻譯資料
  static get_DetialJsonDataStringByfID = "Project/getDetialJsonDataStringByfID";

  //接受案子
  static get_AcceptCase = "Project/AcceptCase";

  //更新為完成狀態
  static get_CompleteStep = "Project/CompleteStep";

  static post_CheckIsHaveNext = "Project/CheckIsHaveNext"; //檢查有沒有下一步驟

  static Authorization =
    "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6IkhsQzBSMTJza3hOWjFXUXdtak9GXzZ0X3RERSIsImtpZCI6IkhsQzBSMTJza3hOWjFXUXdtak9GXzZ0X3RERSJ9.eyJhdWQiOiJodHRwczovL21hbmFnZW1lbnQuY29yZS53aW5kb3dzLm5ldC8iLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC84ODZhOTRlOC01ZTBhLTQ4NDUtOWYxZS1kZmVmZWY0YmFhZWQvIiwiaWF0IjoxNTgxODE1Mzc3LCJuYmYiOjE1ODE4MTUzNzcsImV4cCI6MTU4MTgxOTI3NywiYWNyIjoiMSIsImFpbyI6IkFVUUF1LzhPQUFBQW1ZaFhib09ic0pvWVFSWU9qVC9ld1R5WG5VL0U0OFc0VEVsZWJKVlF2NU9XL2Jjc25YNUNDSHRNeVpxQkk2K1BSUGQyK1VYYnZGWDZrNHNJR3VGditnPT0iLCJhbHRzZWNpZCI6IjE6bGl2ZS5jb206MDAwMzAwMDAyNTkxM0RDRiIsImFtciI6WyJwd2QiXSwiYXBwaWQiOiI3ZjU5YTc3My0yZWFmLTQyOWMtYTA1OS01MGZjNWJiMjhiNDQiLCJhcHBpZGFjciI6IjIiLCJlbWFpbCI6ImNvbnRhY3R1c0B0aGVzdWJwcm8uY29tIiwiZmFtaWx5X25hbWUiOiJMaXUiLCJnaXZlbl9uYW1lIjoiWXZvbiIsImdyb3VwcyI6WyIwNGYzMTdjNS1mMTI4LTQxNzItODE4MS0xOTNjNDgyNGY1MjMiXSwiaWRwIjoibGl2ZS5jb20iLCJpcGFkZHIiOiIzNi4yMjguMTI3LjIzOCIsIm5hbWUiOiJZdm9uIExpdSIsIm9pZCI6ImUyYjdiZWE1LWNjYTQtNDdiOC04MzQ4LTUzYTczYzgyN2E5YiIsInB1aWQiOiIxMDAzMjAwMDhFMjFCM0EyIiwic2NwIjoidXNlcl9pbXBlcnNvbmF0aW9uIiwic3ViIjoiYkJGTnRTS01OZDhJTnRZSnFsTHBmVTE3SHpXb3lnVlEtWTRoQXZkd3FGcyIsInRpZCI6Ijg4NmE5NGU4LTVlMGEtNDg0NS05ZjFlLWRmZWZlZjRiYWFlZCIsInVuaXF1ZV9uYW1lIjoibGl2ZS5jb20jY29udGFjdHVzQHRoZXN1YnByby5jb20iLCJ1dGkiOiIzT0szZkNjcUUwaUVfb3gwRUFzMEFBIiwidmVyIjoiMS4wIiwid2lkcyI6WyI2MmU5MDM5NC02OWY1LTQyMzctOTE5MC0wMTIxNzcxNDVlMTAiXX0.ORiQx-R4-nBPcZsr8vQv0Oiyx4m1s77gNryBVCTwUGuqInQzDZxJwuZJ_ZZZ36STKhqkk8MCbrjtTaWIx82NO8lSn0RxE8z-w1svScuwzPKnFfn_74ZfOXucFrPmWYZ9XlVW5j6YJK4ohY1MMbFp00FvXenf5249Ij1FcOAveElpmrtbPY2xhBLfNXFggHkn6WUTB_NoMqVH3hz41BPzY_Fk9mn_3PXMbZxP6g-bDDSdZlZnsTD5hh7gKuR3TzD6fbcYGgdkkmwHloSF1UYUHcw-eDVhPIVDkUCQ487hERDY5ylXllFvxvewl52g5TtJ2SYfYI14AI2Te_oESOSicQ";

  //發首頁email
  static post_homeContactusMail = "Mail/homeContactusMail";

  // 註冊新用戶
  static post_AddNewFreelancer = "Freelancer/AddNewFreelancer";

  //換密碼
  static post_ChangePassword = "Freelancer/ChangePassword";

  //取得　fMultipleReplacement // GetMultipleReplacement(string fEmail)
  static post_GetMultipleReplacement = "Freelancer/GetMultipleReplacement";
  //更新　fMultipleReplacement
  static post_ChangeMultipleReplacement =
    "Freelancer/ChangeMultipleReplacement";

  //Style
  static post_Style_GetStyleList = "Style/GetStyleList";
  static post_AddNewStyle_p = "Style/AddNewStyle_p";
  static post_Style_GetClientList = "Style/GetClientList";
  static post_Style_GetLanguageList = "Style/GetLanguageList"; //語系選擇
  static post_Style_DeleteStyle = "Style/DeleteStyle";
  static post_Style_GetStyleById = "Style/GetStyleById";

  //client
  static post_Style_AddClient = "Style/AddClient";
  static post_Style_DeleteClient = "Style/DeleteClient";

  //client
  static post_Style_AddLanguage = "Style/AddLanguage";
  static post_Style_DeleteLanguage = "Style/DeleteLanguage";

  static async get_media_sql(apiName) {
    try {
      const response = await axios.get(`${apiName}`, {
        headers: {
          Authorization: `Bearer ${ApiUtils.Authorization}`,
        },
      });
      // console.log(`get_media_sql response ${JSON.stringify(response)}`);
      return response.data;
    } catch (err) {
      // console.log(`get_media_sql err ${err}`);
      return null;
    }
  }
  static async get_sql(apiName, sqlData) {
    try {
      const response = await axios.get(
        `${ApiUtils.cors}${ApiUtils.url}${apiName}`,
        sqlData
      );
      //console.log(`${apiName} response ${JSON.stringify(response.data[0])}`);
      return response.data;
    } catch (err) {
      // console.log(`get_sql err ${err}`);
      return null;
    }
  }

  static async put_sql(apiName, sqlData) {
    try {
      await axios.put(`${ApiUtils.cors}${ApiUtils.url}${apiName}`, sqlData);
      //console.log(`${apiName} response ${JSON.stringify(response.data[0])}`);
    } catch (err) {
      //alert(JSON.stringify(err));
      console.log(`put_sql err ${err}`);
      return null;
    }
  }

  static async delete_sql(apiName, sqlData) {
    try {
      await axios.delete(`${ApiUtils.cors}${ApiUtils.url}${apiName}`, sqlData);
      //console.log(`${apiName} response ${JSON.stringify(response.data[0])}`);
    } catch (err) {
      console.log(`get_sql err ${err}`);
      return null;
    }
  }

  static async post_sql(apiName, sqlData) {
    try {
      const response = await axios.post(
        `${ApiUtils.cors}${ApiUtils.url}${apiName}`,
        sqlData,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
      // console.log(`${apiName} response ${JSON.stringify(response.data)}`);
      return response.data;
    } catch (err) {
      // alert(`post_sql err ${err}`);
      console.log(`get_sql err ${err}`);
      return null;
    }
  }

  //檢查存檔是否成功
  static checkSaveIsSuccess(jsonData) {
    if (typeof jsonData === "number") {
      console.log("成功");

      return true;
    } else {
      console.log("失敗");

      alert(
        "Failed to save data. Please go to Menu > Manage > Export > Source Download to save a local copy."
      );
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/helper/ApiUtils.js